import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import { useModal } from '../contexts/ModalContext';

/**
 * @param {'default' | 'landing'} variant — `landing`: sem botão de chat abaixo (ex.: /lp/), usa bottom-6.
 */
const ScrollToTop = ({ variant = 'default' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { isAnyModalOpen } = useModal();
  const positionCls = variant === 'landing' ? 'bottom-6 right-6' : 'bottom-28 right-6';

  // Função para verificar se deve mostrar o botão
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Função para scrollar ao topo
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <>
      {isVisible && !isAnyModalOpen && (
        <button
          onClick={scrollToTop}
          className={`fixed z-50 bg-primary hover:bg-primary/90 text-white p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl ${positionCls}`}
          aria-label="Voltar ao topo"
          style={{
            backgroundColor: 'var(--primary-color, #000000)',
            '--tw-bg-opacity': '0.9'
          }}
        >
          <FaArrowUp className="w-5 h-5" />
        </button>
      )}
    </>
  );
};

export default ScrollToTop;
